var map = {
	"./account-merge-controller": 428,
	"./account-merge-controller.js": 428,
	"./confirm-email-controller": 429,
	"./confirm-email-controller.js": 429,
	"./course-registration-controller": 430,
	"./course-registration-controller.ts": 430,
	"./invitation-controller": 431,
	"./invitation-controller.ts": 431,
	"./main-registration-controller": 432,
	"./main-registration-controller.js": 432,
	"./native-app-launcher-controller": 433,
	"./native-app-launcher-controller.ts": 433,
	"./oauth-callback-controller": 434,
	"./oauth-callback-controller.js": 434,
	"./reset-password-controller": 435,
	"./reset-password-controller.js": 435,
	"./sign-in-controller": 436,
	"./sign-in-controller.js": 436,
	"./sign-out-controller": 437,
	"./sign-out-controller.js": 437,
	"./temp-login-controller": 438,
	"./temp-login-controller.js": 438
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 860;